/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import * as React from 'react';

interface IComponentProps {
  menuNameOpen: any;
  actionOpen: any;
  action: any;
  label: any;
  columns: any;
  filterComponent: any;
}

const Default: React.FC<IComponentProps> = ({ ...props }) => {
  const actionOpen = (e: any) => {
    props.actionOpen(e, props.columns.name);
  };

  const action = (e: any) => {
    props.action(props.columns.name, e);
  };

  const { columns, filterComponent, label, menuNameOpen } = props;
  return (
    <div
      data-cy={`default-popup-${columns.name}`}
      className={`label ${label ? 'label-primary mb-xs position-relative' : ''} ${
        menuNameOpen[columns.name] === label ? 'open' : ''
      }`}
      style={{ padding: !label ? '0px' : '8px' }}
    >
      {label && (
        <span onClick={actionOpen}>
          <a
            href="#"
            title="#"
            className="dropdown-toggle text-white text-decoration-none"
            data-cy={`filter-select-${columns.name}`}
            id="dropdownMenu13"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            {columns.title} {filterComponent.selectedValue}
          </a>
          <a
            href="#"
            title="#"
            className="text-white"
            onClick={action}
            data-cy={`filter-select-remove-${columns.name}`}
            style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
          >
            <i className="cmd-icon cmd-icon-remove-sm" />
          </a>
        </span>
      )}
      <div
        className="dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open"
        aria-labelledby="dropdownMenu10"
      />
    </div>
  );
};

export default Default;
